import { gql } from '@apollo/client'

export default gql(`
    mutation deleteConfigGroupSchema( $id: ID!) {
        deleteConfigGroupSchema(
            input: {
                id: $id
            }
        ) {
            id
        }
    }`
)
